import type { TourSection } from './types';

// Helper: clickea el botón del tab si no está activo y espera 2 frames
// para que React monte el Card antes de buscar el target.
function openBrandTab(key: string): () => Promise<void> {
  return async () => {
    const btn = document.querySelector<HTMLButtonElement>(
      `[data-tour="brand-tab-${key}"]`,
    );
    if (btn && btn.getAttribute('aria-selected') !== 'true') {
      btn.click();
      await new Promise<void>((resolve) =>
        requestAnimationFrame(() => requestAnimationFrame(() => resolve())),
      );
    }
  };
}

export const brandsListSections: TourSection[] = [
  {
    id: 'filters',
    label: 'Buscar marcas',
    steps: [
      {
        target: '[data-tour="brands-filters"]',
        title: 'Búsqueda de marcas',
        content:
          'Buscar por nombre o slug. Las marcas son las que aparecen en el desplegable cuando creas o editas un producto.',
      },
    ],
  },
  {
    id: 'table',
    label: 'Listado',
    steps: [
      {
        target: '[data-tour="brands-table"]',
        title: 'Tabla de marcas',
        content:
          'Logo, nombre, slug y cantidad de nombres alternativos. Click en la fila para editarla. No se puede borrar una marca si hay productos asociados a ella.',
      },
    ],
  },
  {
    id: 'create',
    label: 'Crear marca nueva',
    steps: [
      {
        target: '[data-tour="brands-new"]',
        title: 'Nueva marca',
        content:
          'Nombre, slug (versión URL-friendly del nombre) y nombres alternativos opcionales (útiles para mapear datos viejos del catálogo). El logo se carga después desde el detalle.',
      },
    ],
  },
];

export const brandsDetailSections: TourSection[] = [
  {
    id: 'tab-general',
    label: 'Tab Datos',
    steps: [
      {
        target: '[data-tour="brand-detail-general"]',
        title: 'Datos generales',
        content:
          'Nombre, slug, nombres alternativos y si está activa. Cambiar el slug rompe los enlaces viejos que apuntaban a esta marca por URL.',
        before: openBrandTab('general'),
      },
    ],
  },
  {
    id: 'tab-logo',
    label: 'Tab Logo',
    steps: [
      {
        target: '[data-tour="brand-detail-logo"]',
        title: 'Logo',
        content:
          'Carga el logo de la marca arrastrándolo o desde el botón. Aparece en el listado de marcas y junto a los productos de esta marca.',
        before: openBrandTab('logo'),
      },
    ],
  },
  {
    id: 'tab-audit',
    label: 'Tab Auditoría',
    steps: [
      {
        target: '[data-tour="brand-detail-audit"]',
        title: 'Historial',
        content:
          'Lista de quién hizo qué con esta marca: creó, editó, cambió logo, etc.',
        before: openBrandTab('audit'),
      },
    ],
  },
];
